import { optionByID, optionCreate, optionDestroy, optionList, optionFormatList, optionUpdate } from '@/services/agency/kpi-options.service'

export default {
	namespaced: true,
	state: {
		// SERVICE OPTION
		optionList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		option: {},

		// SERVICE OPTION FORMAT
		optionFormatList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		option: {},

		// STATUS SERVICE OPTION
		optionStatus: 'pending',
		optionSaveStatus: 'init',
		optionDeleteStatus: 'init',
	},
	getters: {
		// SERVICE OPTION
		getOptionList(state) {
			return state.optionList
		},
		getOption(state) {
			return state.option
		},

		// SERVICE OPTION FORMAT
		getOptionFormatList(state) {
			return state.optionFormatList
		},
		getOptionFormat(state) {
			return state.optionFormat
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE OPTION
		getOptionDeleteStatus(state) {
			return state.optionDeleteStatus
		},
		getOptionSaveStatus(state) {
			return state.optionSaveStatus
		},
		getOptionStatus(state) {
			return state.optionStatus
		},
	},
	mutations: {
		// SERVICE OPTION
		OPTION_LIST(state, value) {
			state.optionList = value
		},
		SET_OPTION(state, value) {
			state.option = value
		},

		// SERVICE OPTION FORMAT
		OPTION_FORMAT_LIST(state, value) {
			state.optionFormatList = value
		},
		SET_OPTION_FORMAT(state, value) {
			state.optionFormat = value
		},

		// STATUS SERVICE OPTION
		OPTION_STATUS(state, value) {
			state.optionStatus = value
		},
		OPTION_SAVE_STATUS(state, value) {
			state.optionSaveStatus = value
		},
		OPTION_DELETE_STATUS(state, value) {
			state.optionDeleteStatus = value
		},
	},
	actions: {
		// Service Option Format
		async fetchOptionFormatList({ commit }, params) {
			commit('OPTION_STATUS', 'pending')
			commit('OPTION_FORMAT_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await optionFormatList(params)
				commit('OPTION_STATUS', 'init')
				commit('OPTION_FORMAT_LIST', data)
				return data
			} catch (error) {
				commit('OPTION_STATUS', 'init')
				throw error
			}
		},

		// Service Option
		async fetchOptionList({ commit }, params) {
			commit('OPTION_STATUS', 'pending')
			commit('OPTION_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await optionList(params)
				commit('OPTION_STATUS', 'init')
				commit('OPTION_LIST', data)
				return data
			} catch (error) {
				commit('OPTION_STATUS', 'init')
				throw error
			}
		},
		async fetchOptionByID({ commit }, params) {
			commit('OPTION_STATUS', 'pending')
			try {
				const { data } = await optionByID(params)
				commit('OPTION_STATUS', 'init')
				commit('SET_OPTION', data.data)
				return data
			} catch (error) {
				commit('OPTION_STATUS', 'init')

				return error
			}
		},
		async saveNewOption({ commit }, params) {
			commit('OPTION_SAVE_STATUS', 'pending')
			try {
				const { data } = await optionCreate(params)
				commit('OPTION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('OPTION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateOption({ commit }, params) {
			commit('OPTION_SAVE_STATUS', 'pending')
			try {
				const { data } = await optionUpdate(params)
				commit('OPTION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('OPTION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteOptionByID({ commit }, params) {
			commit('OPTION_DELETE_STATUS', 'pending')
			try {
				const { data } = await optionDestroy(params)
				commit('OPTION_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('OPTION_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
